import { transport } from 'config/transport';

export function callApiExportCTPVReportForAllCongDoan(academicYear) {
    return transport.get(`/trunguong/congtacphucvu/AnnualReport`, { params: { academicYear }, responseType: 'blob' });
}
